import { replaceImagesBasedOnLanguage } from './replaceImagesBasedOnLanguage';
import { replaceVideosBasedOnLanguage } from './replaceVideosBasedOnLanguage';

export const replaceMediaLanguageAfterLoad = () => {
  window.addEventListener('load', function (event) {
    replaceImagesBasedOnLanguage();
    replaceVideosBasedOnLanguage();
  });
};
